import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import data from "../../../../Json/Language/English";
import hindiDatas from "../../../../Json/Language/Hinid";
import "../../../../StyleSheet/MainComponent/UDSEMployee/Leave.scss";
import AttendanceCard from "../UdsEmployeeDashboard/AttendanceCard";
import {
  SetLeaveTypeDataActions,
  SetTheAttendanceDatasActions,
  SetTheShiftDatasActions,
  SetCreateLeaveAction,
  setTheLeaveApplyDateUDS_employee,
} from "../../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
import HeadingComp from "../UdsEmployeeDashboard/CustomHooks/HeadingComp";
import useLanguageSelector from "../UdsEmployeeDashboard/CustomHooks/useLanguageSelector";
import ReactTable from "../../../AppComponent/Table";
// import AttendanceTable from "../../Appcomponent/AttendanceTable";
import approved from "../../../../Assets/MainComponent/approved.svg";
import declined from "../../../../Assets/MainComponent/decline.svg";
import pending from "../../../../Assets/MainComponent/pending.svg";
import swal from "sweetalert2";
import {
  format,
  addDays,
  eachDayOfInterval,
  isValid,
  parseISO,
} from "date-fns";
import BackImage from "../../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";


import _, { values } from "lodash";
import LeaveApplyUDS from "./LeaveApply";

const LeaveUDS = () => {
  const Swal = require("sweetalert2");

  const EnglishData = data;
  const HindiData = hindiDatas;
  const hindiApplyLeave = HindiData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //   const englishApplyLeave = EnglishData.Home.ApplyLeaveCard.Apply[0];
  const englishApplyLeave = EnglishData;

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [search, setsearch] = useState("")
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state);
  const responseData = useSelector(
    (state) => state.AttenDanceCall.AttenDanceData
  );

  const [leaveState, setLeaveStatus] = useState({
    pending_leave: responseData?.data?.casual_leave_pending,
    total_leave: responseData?.data?.casual_leave,
    personal_leave: responseData?.data?.personal_leave,
    casual_leave: responseData?.data?.casual_leave,
    balance_ot_hours: responseData?.data?.balance_ot_hours,



    leave_valid_until: responseData?.data?.permission_valid_until,
  });
  const userId = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
  );
  const FileterState = {
    status: ""
  }
  const [selectVal, SetSelectval] = useState(FileterState);
  const [OptionValues, setOptionvalues] = useState([{ value: "", label: "All" }])

  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Rejected" },
    { value: "approved", label: "Approved" },
  ];
  const [LevaeApply, setLeaveApply] = useState(false);
  const [sno, setsno] = useState(0);


  useEffect(() => {
    const payload = {
      page_size: 20,
      page: dtpageindex,
      status: selectVal.status,
      search: search

    };
    dispatch(SetTheAttendanceDatasActions(payload));
  }, [dtpageindex, selectVal, search]);

  const ClearState = (counts) => {
    setOptionvalues({ value: "", label: "All" })
    SetSelectval({
      ...selectVal,
      status: "",

    });
  };

  const count = (Counts, values, sel, SelectedValues) => {
    setOptionvalues(SelectedValues)
    SetSelectval({
      ///Completed
      ...selectVal,
      status: SelectedValues.value
    });
  };

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);

  }
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );
  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);


  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  useEffect(() => {
    setLeaveStatus((prev) => ({
      ...prev,
      pending_leave: responseData?.data?.casual_leave_pending,
      total_leave: responseData?.data?.casual_leave,
      leave_valid_until: responseData?.data?.permission_valid_until,
    }));
    const Object = [];

    state.AttenDanceCall.Responsess.map((item) => {
      if (item.status == "approved") {
        Object.push({ fromdata: item.from_date, todate: item.to_date });
      }
    });

    // console.log(Object ,"Object");
    dispatch(setTheLeaveApplyDateUDS_employee(Object));
  }, [responseData?.data?.casual_leave_pending]);

  const dispatchApiCall = (payload) => {
    dispatch(SetTheAttendanceDatasActions(payload));
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const [selectedDates, setSelectedDates] = useState({ date: [] });
  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };
  const columns =
    useMemo(
      () => [
        {
          Header: "S.NO",
          accessor: "",
          Cell: (row) => {
            console.log(row.row);
            console.log(sno);
            return <p>{Number(sno + row.row.index + 1)}</p>;
          },
        },
        {
          Header: "REQUESTS",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <span>
                  {row.row.original.leave_type != null &&
                    row.row.original.leave_type.leave_type != "" ? (
                    <span >
                      {row.row.original.leave_type.leave_type}
                    </span>
                  ) : (
                    <span>{"---"} </span>
                  )}
                </span>
              </>
            );
          },
        },
        {
          Header: "PURPOSE",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <span>
                  {row.row.original.notes != null &&
                    row.row.original.notes != "" ? (
                    <span >
                      {row.row.original.notes}
                    </span>
                  ) : (
                    <span>{"---"} </span>
                  )}
                </span>
              </>
            );
          },
        },

        {
          Header: "FROMDATE - TODATE",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                <span>
                  {row.row.original.from_date != null &&
                    row.row.original.from_date != "" ? (
                    <span >
                      {row.row.original.from_date} to{" "}
                      {row.row.original.to_date != undefined &&
                        row.row.original.to_date != null
                        ? row.row.original.to_date
                        : "-"}
                    </span>
                  ) : (
                    <span>{"---"} </span>
                  )}
                </span>
              </>
            );
          },
        },

        {
          Header: "APPLIED DATE",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.created_at;
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <span>
                  {`${row.row.original.created_at.slice(0, 10) + "  " + formattedTime
                    }`}
                </span>
              </>
            );
          },
        },


        {
          Header: "APPROVED DATE",
          accessor: "",
          Cell: (row) => {
            const dateString = row.row.original.approved_date;

            // Check if approved_date is null or empty
            if (!dateString) {
              return <span>--</span>; // Display -- if approved_date is null
            }

            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;

            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <span>
                  {`${dateString.slice(0, 10) + "  " + formattedTime}`}
                </span>
              </>
            );
          },
        },

        {
          Header: "STATUS",
          accessor: "",
          Cell: (row) => {
            const originalString = row.row.original.status;
            const capitalizedString = capitalizeFirstLetter(originalString);

            return (
              <>
                {row.row.original.status != undefined ? (
                  <>
                    <img
                      src={
                        row.row.original.status == "approved"
                          ? approved
                          : row.row.original.status === "pending"
                            ? pending
                            : declined
                      }
                      alt="img"
                      width={"25px"}
                      height={"25px"}
                    />
                    &nbsp;
                    <span>
                      {row.row.original.status == "approved"
                        ? "Approved"
                        : row.row.original.status === "pending"
                          ? "Pending"
                          : "Decline"}
                    </span>
                  </>
                ) : (
                  // <button
                  //   className="StatusButton"
                  //   style={{
                  //     background:
                  //       row.row.original.status == "approved"
                  //         ? "green"
                  //         : row.row.original.status == "pending"
                  //         ? "#234492"
                  //         : "red",
                  //   }}
                  // >
                  //   {capitalizedString}
                  // </button>
                  <span>{"--"}</span>
                )}
              </>
            );
          },
        },

        // {
        //   Header: "ACTIONS",
        //   accessor: "",
        //   Cell: ({ row }) => {
        //     const { from_date, to_date } = row.original; // Assuming row.original contains the data

        //     // const generateDateList = (start, end) => {
        //     //   const startDate = parseISO(start);
        //     //   const endDate = parseISO(end);

        //     //   if (!isValid(startDate) || !isValid(endDate)) {
        //     //     console.error("Invalid date format");
        //     //     return [];
        //     //   }

        //     //   return eachDayOfInterval({ start: startDate, end: endDate }).map(
        //     //     (date) => format(date, "yyyy-MM-dd")
        //     //   );
        //     // };
        //     const generateDateList = (start, end) => {
        //       try {
        //         const startDate = parseISO(start);
        //         const endDate = parseISO(end);

        //         console.log("Parsed dates:", startDate, endDate);

        //         if (!isValid(startDate) || !isValid(endDate)) {
        //           console.error("Invalid date format");
        //           return [];
        //         }

        //         const dates = eachDayOfInterval({ start: startDate, end: endDate });
        //         console.log("Generated dates:", dates);

        //         return dates.map((date) => format(date, "yyyy-MM-dd"));
        //       } catch (error) {
        //         console.error("Error generating date list:", error);
        //         return [];
        //       }
        //     };
        //     const dateList = generateDateList(from_date, to_date);
        //     const showSwal = () => {
        //       const Levaeit = row.original.leave_type.id;
        //       const { leave_type } = row.original.leave_type.unique_value;
        //       MySwal.fire({
        //         title: "Select a Date",
        //         html: (
        //           <div style={{ display: "flex", flexDirection: "column" }}>
        //             <>
        //               {from_date != undefined &&
        //               from_date != null &&
        //               to_date != undefined &&
        //               to_date != null ? (
        //                 <>
        //                   {dateList.length === 0 ? (
        //                     <p>No valid dates available.</p>
        //                   ) : (
        //                     dateList.map((date) => (
        //                       // <div key={date} className="col-sm-4 mt-3">
        //                       //   <input
        //                       //     type="radio"
        //                       //     name="dates"
        //                       //     // value={date}
        //                       //     multiple
        //                       //     onChange={(e) => {
        //                       //       handleDateChange(date);
        //                       //     }}
        //                       //   />
        //                       //   <label htmlFor={date}>{date}</label>
        //                       // </div>
        //                       <div key={date} className="col-sm-4 mt-3">
        //                         <input
        //                           type="checkbox"
        //                           id={date}
        //                           name="dates"
        //                           value={date}
        //                         />
        //                         <label htmlFor={date} style={{marginLeft:"12px"}}>{date}</label>
        //                       </div>
        //                     ))
        //                   )}
        //                   <div className="row">
        //                     <p
        //                       style={{
        //                         display: "block",
        //                         width: "100%",
        //                         color: "red",
        //                       }}
        //                     >
        //                       Please select one of the dates above.
        //                     </p>
        //                   </div>
        //                 </>
        //               ) : (
        //                 <div>
        //                   <input
        //                     type="radio"
        //                     id={from_date}
        //                     name="dates"
        //                     value={from_date}
        //                   />
        //                   <label htmlFor={from_date} style={{marginLeft:"12px"}}>{from_date}</label>
        //                 </div>
        //               )}
        //             </>
        //           </div>
        //         ),
        //         showCancelButton: true,
        //         confirmButtonText: "Submit",
        //         confirmButtonColor: "#234492",
        //         cancelButtonColor: "#6c757d",
        //         preConfirm: () => {
        //           const selectedOptions = Array.from(
        //             document.querySelectorAll('input[name="dates"]:checked')
        //           ).map((checkbox) => checkbox.value);
        //           if (selectedOptions.length === 0) {
        //             Swal.showValidationMessage(
        //               "You need to select at least one date."
        //             );
        //           }
        //           return selectedOptions;
        //         },
        //       }).then((result) => {
        //         if (result.isConfirmed) {
        //           Swal.fire(`You selected: ${result.value}`);
        //           const date = result.value;
        //           console.log(date[0], "4792387date", date);
        //           var fromDate = "";
        //           var Todate = "";
        //           if (date) {
        //             if (date.length == 2 || date.length > 2) {
        //               // fromDate = date[date.length - 1];
        //               // Todate = date[0];
        //               fromDate = date[0];
        //               Todate = date[date.length - 1];
        //             } else if (date.length == 1) {
        //               fromDate = date[0];
        //               Todate = null;
        //             }
        //           }
        //           Swal.fire({
        //             title: "Do you want to Cancel Leave Request?",
        //             icon: "warning",
        //             showCancelButton: true,
        //             confirmButtonColor: "#234492",
        //             cancelButtonColor: "#6c757d",
        //             confirmButtonText: "Yes, cancel it!",
        //             input: "text",
        //             inputPlaceholder: "Reason for cancel...",
        //             inputValidator: (value) => {
        //               if (!value) {
        //                 return "You need to provide a reason for canceling";
        //               }
        //             },
        //           }).then((result) => {
        //             if (result.isConfirmed) {
        //               const reason = result.value; // Retrieve the value entered by the user

        //               const formData = new FormData();
        //               formData.append(
        //                 "data",
        //                 JSON.stringify({
        //                   // from_date: date[0],
        //                   // to_date: null,
        //                   from_date: fromDate,
        //                   to_date: Todate,
        //                   notes: reason,
        //                   user_id: userId,
        //                   request_type: "cancel",
        //                   leave_type: leave_type,
        //                 })
        //               );
        //               const payload = {
        //                 formData: formData,
        //                 post: 2,
        //                 id: Levaeit,
        //               };
        //               dispatch(SetCreateLeaveAction(payload));
        //             } else if (result.dismiss === Swal.DismissReason.cancel) {
        //               Swal.fire({
        //                 text: " Employee verification as been cancel",
        //                 icon: "error",
        //               });
        //               Swal.close();
        //             }
        //           });
        //         }
        //       });
        //     };

        //     return (
        //       <div
        //         className="actions"
        //         style={{
        //           display: "flex",
        //           justifyContent: "flex-start",
        //           gap: "5px",
        //         }}
        //       >
        //         <button
        //           className="btn Status"
        //           component="span"
        //           onClick={(e) => {
        //             if (
        //               row.original.leave_type.id != undefined &&
        //               row.original.leave_type.id != null
        //             ) {
        //               showSwal();
        //             }
        //           }}
        //         >
        //           <span>
        //             <i
        //               className="fa-solid fa-minus"
        //               style={{ fontSize: "13px", paddingRight: "3px" }}
        //             ></i>
        //             Cancel
        //           </span>
        //         </button>
        //       </div>
        //     );
        //   },
        // },
      ], [sno]
    );

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div className="leaveWrapper">
          <div className="row ButtonPrevious Filters"
            style={{
              padding: "4px 4px",
              margin: "0px",
              position: "relative",
              zIndex: "30",
              marginLeft: "0px",
              marginRight: "0px",
            }}>
            <div className="col-12 leaveHeading text-left">
              <h3>LEAVE</h3>
            </div>
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  navigate("/customattendace");
                }}
              >
                <img className="PreviousPages" src={BackImage} />
                <span></span>

              </button>
            </div>
            <div className="col leaveButton">
              <button
                className="ButtonCSS"
                onClick={() => {
                  // navigate("/leave_apply");
                  setLeaveApply(true)
                }}
                style={{ marginBottom: "20px", background: "#234492 " }}
              >
                {useLanguageSelector(
                  EnglishData.leave.applyButton,
                  HindiData.leave.applyButton
                )}
              </button>
            </div>
          </div>
          <div className="row LeaveStatusCard ShiftBasedCards ColorPatternForLeaveCards">
            <div className="col-4 ">
              <div className="card ">
                <div className="card-body ">
                  <div className="row partOne">
                    <div className="col-6 ShiftHeaders ShiftHeadersCardStyle  text-left">
                      <span className="Availablehead">{"AVAILABLE"}</span>
                    </div>
                  </div>
                  <div className="row partOne">
                    <div className="col-6 ShiftHeaders ShiftHeadersCardStyle  text-left">
                      <span>{"Personal Leaves"}</span>
                    </div>
                    <div className="col-6 text-right DAYS">
                      <>
                        <span> {leaveState.pending_leave}</span>

                      </>
                    </div>
                  </div>
                  <div className="row partOne">
                    <div className="col-6 ShiftHeaders ShiftHeadersCardStyle  text-left">
                      <span>{"Casual Leaves"}</span>
                    </div>
                    <div className="col-6 text-right DAYS">
                      <>
                        <span> {leaveState.casual_leave}</span>

                      </>
                    </div>
                  </div>
                  <div className="row partOne">
                    <div className="col-6 ShiftHeaders ShiftHeadersCardStyle  text-left">
                      <span>{"OT Hours"}</span>
                    </div>
                    <div className="col-6 text-right DAYS">
                      <>
                        <span> {leaveState.balance_ot_hours} hours</span>

                      </>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
          <div className="col-12 leaveSubHeading">
            <ReactTable
              data={state.AttenDanceCall.Responsess}
              datacount={10}
              columns={columns}
              // dispatchApiCall={dispatchApiCall}
              pagesize={pagesize}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              Search={true}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              Filter={true}
              values={OptionValues}
              options={options}
              count={count}
              ClearState={ClearState}
              onChange={tochange}
              setsno={setsno}
              sno={sno}
              id={"spe"}


            />
          </div>

        </div>
      </div>
      {LevaeApply == true ?
        <LeaveApplyUDS show={LevaeApply} setshow={setLeaveApply} />
        : null}
    </>
  );
};

export default LeaveUDS;
